import { useEffect, useState } from "react";
import api from "@/lib/api";
import { captureRefFromUrl } from "@/lib/affiliate";
import { usePageMeta } from "@/lib/usePageMeta";
import { Navbar } from "@/components/guest/Navbar";
import { Hero } from "@/components/guest/Hero";
import { About, Gallery } from "@/components/guest/Gallery";
import { Amenities } from "@/components/guest/Amenities";
import { BookingSection } from "@/components/guest/BookingSection";
import { Reviews } from "@/components/guest/Reviews";
import { Guide } from "@/components/guest/Guide";
import { LocationMap } from "@/components/guest/LocationMap";
import { PoliciesFaq } from "@/components/guest/PoliciesFaq";
import { Contact } from "@/components/guest/Contact";
import { Footer } from "@/components/guest/Footer";
import { InstallPrompt } from "@/components/guest/InstallPrompt";

export default function GuestSite() {
  const [property, setProperty] = useState(null);
  const [reviews, setReviews] = useState([]);

  const city = property?.location?.city || property?.city || "Apache Junction, Arizona";
  usePageMeta({
    title: property?.name ? `${property.name} | Book Direct & Save` : "Book Direct Vacation Rental in Apache Junction, AZ",
    description: property?.name
      ? `Book ${property.name} directly and save vs. Airbnb/VRBO. A cozy, family-friendly vacation rental in ${city} — real-time availability, instant quotes, and no extra platform fees.`
      : "A cozy, family-friendly vacation rental in Apache Junction, Arizona. Book direct for the best rate — real-time availability, instant quotes, and no extra Airbnb/VRBO fees.",
    path: "/",
  });

  useEffect(() => {
    captureRefFromUrl();
    api.get("/property").then((r) => {
      setProperty(r.data);
    });
    api.get("/reviews").then((r) => setReviews(r.data));
  }, []);

  if (!property) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  return (
    <div className="bg-background">
      <Navbar name={property.name} />
      <Hero property={property} />
      <About property={property} />
      <Gallery property={property} />
      <Amenities property={property} />
      <BookingSection property={property} />
      <Reviews reviews={reviews} property={property} />
      <Guide property={property} />
      <LocationMap property={property} />
      <PoliciesFaq property={property} />
      <Contact property={property} />
      <Footer property={property} />
      <InstallPrompt appName="MYAZBNB" />
    </div>
  );
}
